module.exports = __webpack_public_path__ + "static/media/edu-color.d26f31dd.svg";